import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Loader, Segment, Header, Button,Icon,Modal,Popup } from "semantic-ui-react";
import OrdersList from "../lists/OrdersList";
import OrdersFilter from "../filters/OrdersFilter";

class OrdersSection extends Component {
  state = {
    filteredOrders: [],
    allOrders: true,
    selectdOrder : null,
    showModal:false,
    aiLoading:true,

    lastFilter: this.props.filterRange || {
      startDate: null,
      endDate: null,
      text: null,
    },
    ordersWithExams: [],
  };

  handleSelectOrder = (order) => {
    this.setState({ selectedOrder: order });

    this.props.showPatientOrderResults(order.orderNumber);
  };

  /*onInputChange = (e) => {
  
    const filter = e.target.value;
    console.log(this.props)
    if (filter.length > 2) {
      
      const filteredOrders = this.props.orders.filter(
        (order) => {
        
          const orderMatches = order.orderNumber.toLowerCase().includes(filter);
          const orderHisMatches = order.orderHis.toLowerCase().includes(filter);

          const exams = this.props.exams.examsByOrder[order.orderNumber] || [];
          const examMatches = exams.some((exam) => exam.nombre_examen.toLowerCase().includes(filter));
         

          return orderMatches || orderHisMatches || examMatches
          
        }
      );
      this.setState({ filteredOrders, allOrders: false });
    } else {
      this.setState({ filteredOrders: [], allOrders: true });
    }
  };*/

  onInputChange2 = (e) => {
  const filter = e.target.value.toLowerCase();

  if (filter.length > 2) {
    const examsByOrder = this.props.exams.examsByOrder || {};
    console.log('FILTERED',examsByOrder)
    const filteredOrders = this.props.orders
      .map((order) => {

        const orderData = examsByOrder[order.orderNumber] || {};

        const allExams = orderData.exams || [];

        const filteredExams = allExams.filter((exam) =>
          exam.nombre_examen?.toLowerCase().includes(filter)
        );

        console.log('FILTERED',filteredExams)

        const isOrderSpecial = orderData.isOrderSpecial || false;

        /*const filteredExams = (examsByOrder[order.orderNumber] || [])
        .filter(exam => exam.nombre_examen.toLowerCase().includes(filter))*/

        // Si la orden NO contiene exámenes filtrados, no se muestra
        if (filteredExams.length === 0 && !isOrderSpecial ) return null;

        return {
          ...order,          // ← Mantenemos toda la estructura intacta
          examsFiltered: filteredExams, // ← Solo los exámenes filtrados
          isOrderSpecial
        };
      })
      .filter(Boolean); // Remueve los null

    this.setState({ filteredOrders, allOrders: false });

  } else {
    this.setState({ filteredOrders: [], allOrders: true });
  }
  };

onInputChange = (e) => {
  const filter = (e.target.value || "").trim().toLowerCase();

  if (filter.length < 3) {
    this.setState({
      filteredOrders: [],
      allOrders: true,
    });
    return;
  }

  const examsState = this.props.exams || {};
  const examsByOrder = examsState.examsByOrder || examsState;
  const orders = this.props.orders || [];

  const filteredOrders = orders
    .map((order) => {
      const orderData = examsByOrder[order.orderNumber] || {};

      const exams = Array.isArray(orderData)
        ? orderData
        : Array.isArray(orderData.exams)
          ? orderData.exams
          : [];

      const examsFiltered = exams.filter((exam) =>
        (exam.nombre_examen || "")
          .toLowerCase()
          .includes(filter)
      );

      if (examsFiltered.length === 0) {
        return null;
      }

      return {
        ...order,
        examsFiltered,
        isOrderSpecial: orderData.isOrderSpecial || false,
      };
    })
    .filter(Boolean);

  this.setState({
    filteredOrders,
    allOrders: false,
  });
};


  componentDidUpdate(prevProps) {
  if (this.props.orders !== prevProps.orders || this.props.exams !== prevProps.exams) {
    const examsBy = this.props.exams.examsByOrder;

    if (examsBy && typeof examsBy === 'object') {
      // Mapeamos las órdenes, pero ahora filtra solo el examen que coincide con el filtro.
      const ordersWithExams = this.props.orders.map((order) => {
        // Obtén todos los exámenes asociados con esta orden
        const orderData = examsBy[order.orderNumber] || {};
        const exams = orderData.exams || [];
        const isOrderSpecial = orderData.isOrderSpecial || false;

        // Verificamos si lastFilter.text existe y si no, lo tratamos como una cadena vacía
        const filterText = (this.state.lastFilter && this.state.lastFilter.text) ? this.state.lastFilter.text.toLowerCase() : '';

        // Filtra los exámenes que coinciden con el filtro de búsqueda
        const filteredExams = exams.filter((exam) => 
          exam.nombre_examen && 
          typeof exam.nombre_examen === 'string' && 
          exam.nombre_examen.toLowerCase().includes(filterText)
        );

        return {
          ...order,
          // Si hay exámenes filtrados, toma solo el primer examen que coincida
          examName: filteredExams.length > 0 
            ? filteredExams[0].nombre_examen // Solo el examen que coincide
            : "Examen no disponible",
        };
      });

      this.setState({ ordersWithExams });
    }
  }
}

  componentDidMount() {
    const examsBy = this.props.exams.examsByOrder;
    
    // Si tenemos exámenes por orden y lastFilter.text es válido, procedemos
    if (examsBy && typeof examsBy === 'object' && this.state.lastFilter && this.state.lastFilter.text) {
      const filterText = this.state.lastFilter.text.toLowerCase();

      const ordersWithExams = this.props.orders.map((order) => {

        const orderData = examsBy[order.orderNumber] || {};
        const exams = orderData.exams || [];

        // Filtra los exámenes que coinciden con el filtro de búsqueda
        const filteredExams = exams.filter((exam) => 
          exam.nombre_examen && 
          typeof exam.nombre_examen === 'string' && 
          exam.nombre_examen.toLowerCase().includes(filterText)
        );

        return {
          ...order,
          // Si hay exámenes filtrados, toma solo el primer examen que coincida
          examName: filteredExams.length > 0 
            ? filteredExams[0].nombre_examen
            : "Examen no disponible",
        };
      });

      this.setState({ ordersWithExams });
    }
  }

  handleFilterSubmit = ({ text, startDate, endDate }) => {
    this.setState({
      lastFilter:{ text, startDate, endDate },
      allOrders: false
    });
  }

  toggleModal = () => {
    this.setState((prev) => ({showModal: !prev.showModal}))
  }

  returnToPatientsSearch = () => {
    this.setState({
      allOrders: false,
      filteredOrders: [],
      lastFilter: this.props.filterRange
    });
  }
  
  render() {
    const { listReady } = this.props;
    const { filteredOrders, allOrders,showModal, aiLoading, lastFilter, ordersWithExams } = this.state;

    return (
      <div>
        {!listReady ? (
          <Dimmer active inverted>
            <Loader>Cargando...</Loader>
          </Dimmer>
        ) : (
          <Segment>
            <Header as="h2">
              Ordenes de {this.props.patient_fullname}
              <Header.Subheader>
                Identificación: {this.props.patient_id}
              </Header.Subheader>
            </Header>
             <Button
                  color="blue"
                  icon="arrow left"
                  content="Volver a búsqueda"
                  onClick={() => this.props.showPatientsList(lastFilter)}
                  style={{ marginBottom: "20px" }}
                />
            <OrdersFilter
              onInputChange={this.onInputChange}
              //placeholder="Buscar por Nombre de examén , Numero de Orden LIS ó Numero de Orden HIS "
              placeholder="Buscar por nombre de examén"
              initialFilter={lastFilter}
              onFilterSubmit={this.handleFilterSubmit}
            />
            <OrdersList
                selectedPatient={this.props.selectedPatient}
                selectedPatientID={this.props.selectedPatientID}
                showPatientOrderResults={this.props.showPatientOrderResults}
                showPatientOrderResultsOne={this.props.showPatientOrderResultsOne}
                orders={allOrders ? this.props.orders : filteredOrders}
                //orders={allOrders ? ordersWithExams : filteredOrders }
                onOrderClick={this.handleSelectOrder}
            />
          </Segment>
        )}
        
          {/*<Popup
            content="Interpretar resultados con IA"
            position="top right"
            trigger={
              <Button
                circular
                color="purple"
                icon={<Icon name="lab"/>}
                size="big"
                onClick={this.toggleModal}
                style={{
                  position:"fixed",
                  bottom:"100px",
                  right:"10px",
                  zIndex:1000,
                  boxShadow:"0px 4px 8px rgba(0,0,0,0.25)",
                  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                  color: "#fff",
                  border: "none",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = "scale(1.1)";
                  e.currentTarget.style.boxShadow = "0px 8px 16px rgba(0,0,0,0.35)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0px 6px 12px rgba(0,0,0,0.25)";
                }}
          />
          }/>

          <Modal
            open={showModal}
            onClose={this.toggleModal}
            size="large"
            closeIcon
          >
          
          <Modal.Header>
            <Icon name="lab">Interpretación con IA</Icon>
          </Modal.Header>
          <Modal.Content>
            {aiLoading ? (
            <Dimmer active inverted>
              <Loader>Entrenando modelo IA, en Desarrollo</Loader>
            </Dimmer>
            ):(
            <Segment>
              <Header as="h3">Resultado:</Header>
              <p>resultados con ia .......</p>
            </Segment>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.toggleModal}>
              <Icon name="close"></Icon>
            </Button>
            <Button color="green" onClick={this.toggleModal}>
              <Icon name="check"></Icon>
            </Button>
          </Modal.Actions>
          </Modal>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.allPatientOrders.orders,
    exams: state.examsByOrder || [],
    listReady: !!state.allPatientOrders.orders,
    patient_id: state.selectedPatient.patient_id,
    patient_fullname: state.selectedPatient.fullname,
    filterRange: state.patientOrderResults.filterRange,
    lastFilteredPatients: state.examsByOrder.lastFilteredPatients || []
  };
};

export default connect(mapStateToProps)(OrdersSection);
